import jQuery from "jquery";
import Vue from "vue";

const re = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/;
let $ = jQuery;

export default () => {
  Vue.directive("is-mobile", {
    isEmpty: true,
    bind(el) {
      let isMobile = re.test(navigator.userAgent);
      if (isMobile) {
        $(el).addClass("is-mobile");
      }
    },
    unbind(el) {
      if ($(el).hasClass("is-mobile")) {
        $(el).removeClass("is-mobile");
      }
    }
  });
};
